import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircle,
  faCircleNotch,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";

export default function SensorDisplay({ sensor, updateSelectedForBarGraph }) {
  const [pumpLogDateRef, setPumpLogDateRef] = useState(
    new Date().toLocaleString("en-US", {
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
  );

  useEffect(() => {
    const clockTimer = setInterval(() => {
      setPumpLogDateRef(
        new Date().toLocaleString("en-US", {
          timeZone: "America/New_York",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
      );
    }, 1000);

    return () => clearInterval(clockTimer);
  }, []);

  function formatRunTime(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const formattedSeconds = seconds.toString().padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  function displaySensor(sensor) {
    let iconClassName = "okStatusCircle";
    let className = "okStatus";
    let icon = "faCircle";
    let message = "";

    if (sensor.type === "pump") {
      if (sensor.running) {
        message = sensor.dashboardRunningMessage;
        className = "okStatusGreen";
      } else {
        message = sensor.dashboardStoppedMessage;
        icon = "faCircleNotch";
      }
    } else if (sensor.type === "alarm") {
      if (sensor.active) {
        message = sensor.dashboardActiveMessage;
        className = "emStatus";
        iconClassName = "emStatusCircle";
      } else {
        message = sensor.dashboardInactiveMessage;
      }
    }

    return (
      <div className="sectionSpacer">
        <div className="inputName">{sensor.deviceDescription}</div>
        <div className={`${className}`}>
          <FontAwesomeIcon
            className={`${iconClassName}`}
            icon={icon === "faCircle" ? faCircle : faCircleNotch}
          />
          {message}
        </div>
        {sensor.type === "pump" && (
          <div className="marginTop">
            <div>
              Today's Start Count:{" "}
              {sensor.pumpLogDate === pumpLogDateRef ? sensor.runCount : "0"}
            </div>
            <div className="sectionSpacer4">
              Today's Run Time:{" "}
              {sensor.pumpLogDate === pumpLogDateRef
                ? formatRunTime(sensor.runTime)
                : "00:00:00"}
            </div>
            <FontAwesomeIcon
              className="logsBtn"
              icon={faChartLine}
              onClick={() =>
                updateSelectedForBarGraph({
                  id: sensor.id,
                  name: sensor.deviceDescription,
                })
              }
            />
          </div>
        )}
      </div>
    );
  }

  return <div>{displaySensor(sensor)}</div>;
}
